import React, { Fragment } from "react";
import { SettingTwoTone } from '@ant-design/icons';
import useEditColumns from './UseEditColumns';
import {useCommonStore} from "@/store/useCommonStore";

const ColumnSettings = (props) => {
    const { topic, colsettings, list, onFinish } = props;
    // const user = useSelector(s=>s.common.user);
    const user = useCommonStore.use.user();
    const { show: showEditColumnModal, WscEditColumnsModal } = useEditColumns({ topic, colsettings, list });
    if(user != null && ["13987193193", "13769181072"].includes(user.Phone)) {
    return (<Fragment>
        <SettingTwoTone onClick={() => { showEditColumnModal(); }} />
      <WscEditColumnsModal onFinish={() => {
        onFinish();
      }} />
    </Fragment>);
     } else {
       return null;
     }
}

export default ColumnSettings;
